// extracted by mini-css-extract-plugin
module.exports = {"ul":"AdvancedArticle_ul__5GQ93","li":"AdvancedArticle_li__1odLA","inputCb":"AdvancedArticle_inputCb__2IHPL","label":"AdvancedArticle_label__3d4Kc"};